var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloverLogoPurple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 28,
    viewBox: "0 0 115 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2810_186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 115,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.934 0H0V28H114.934V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2810_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3267 18.9113C45.1217 21.4912 42.5609 22.5164 39.9648 22.5164C35.0566 22.5164 31.1445 19.0169 31.1445 14.4219C31.1445 9.8621 34.8789 6.32736 39.7868 6.32736C42.3832 6.32736 44.9438 7.35247 47.1488 9.93276L43.8767 12.2303C42.7032 10.5692 41.3517 9.89742 39.7868 9.89742C37.2618 9.89742 35.1989 11.9124 35.1989 14.4219C35.1989 16.9667 37.4395 18.9463 39.9648 18.9463C41.5294 18.9463 42.9166 18.2751 44.1258 16.7547L47.3267 18.9113Z",
    fill: "#442255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1387 0H53.2288V22.1985H49.1387V0Z",
    fill: "#442255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.04 6.32736C68.9479 6.32736 72.8602 9.8621 72.8602 14.4219C72.8602 18.9819 68.9479 22.5164 64.04 22.5164C59.1323 22.5164 55.1846 18.9819 55.1846 14.4219C55.1846 9.8621 59.1323 6.32736 64.04 6.32736ZM64.04 19.0877C66.6007 19.0877 68.9479 17.0375 68.9479 14.4219C68.9479 11.8063 66.6007 9.75606 64.04 9.75606C61.4439 9.75606 59.1323 11.8063 59.1323 14.4219C59.1323 17.0375 61.4439 19.0877 64.04 19.0877Z",
    fill: "#442255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2109 6.64542H77.0124L80.889 14.9523L85.0857 6.64542H89.5316L80.889 23.153L72.2109 6.64542Z",
    fill: "#442255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.717 20.431C102.152 21.7389 99.9823 22.5164 97.7061 22.5164C92.7982 22.5164 88.8506 18.9819 88.8506 14.4219C88.8506 9.8621 92.4427 6.32736 97.3506 6.32736C102.258 6.32736 105.459 9.8621 105.459 14.4219V15.5884H92.9404C93.5094 17.6385 95.5011 19.0877 97.7061 19.0877C99.0579 19.0877 100.231 18.6635 101.298 17.5678L103.717 20.431ZM101.156 12.2656C100.551 10.8519 99.2 9.75606 97.3506 9.75606C95.5369 9.75606 94.043 10.7458 93.2961 12.2656H101.156Z",
    fill: "#442255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.465 13.4675C107.465 9.75605 110.31 6.64542 114.934 6.64542V10.2862C112.942 10.2862 111.52 11.4882 111.52 13.9625V22.1985H107.465V13.4675Z",
    fill: "#442255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6645 7.28527C12.6645 3.81195 9.82813 0.991699 6.3309 0.991699C2.8345 0.991699 0 3.80835 0 7.28167C0 10.755 2.83445 13.5788 6.33249 13.5788H12.6645V7.28527Z",
    fill: "#442255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4414 7.28529C14.4414 3.81197 17.2779 0.99173 20.7751 0.99173C24.2715 0.99173 27.106 3.80838 27.106 7.28171C27.106 10.755 24.2715 13.5788 20.7734 13.5788H14.4414V7.28529Z",
    fill: "#442255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4414 21.6379C14.4414 25.1147 17.277 27.9315 20.7757 27.9315C24.2704 27.9315 27.106 25.1168 27.106 21.64C27.106 18.1665 24.2704 15.3443 20.7734 15.3443H14.4414V21.6379Z",
    fill: "#442255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6645 21.638C12.6645 25.1147 9.82895 27.9315 6.33037 27.9315C2.83562 27.9315 0 25.1168 0 21.6401C0 18.1665 2.83558 15.3445 6.33252 15.3445H12.6645V21.638ZM6.33037 26.1568C8.84354 26.1568 10.8882 24.1307 10.8882 21.6401V17.1109H6.33615C3.82184 17.1109 1.77614 19.1505 1.77614 21.6401C1.77614 24.1307 3.81908 26.1568 6.33037 26.1568Z",
    fill: "#442255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloverLogoPurple);
export default __webpack_public_path__ + "assets/media/clover-logo-purple.8e49d612f5cde978c8411876407e9ead.svg";
export { ForwardRef as ReactComponent };